import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    outerContainer: {
        display: 'flex',
        marginInline: 'auto',
        width: '100%',
        height: '100%',
    },
    container: {
        width: '100%',
        height: '100%',
    },
    containerUninitialized: {
        overflow: 'scroll',
    },
    table: {
        width: 'max-content',
        height: 'max-content',
    },
});
